import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "draivn-help-center-content" }
const _hoisted_2 = { class: "content-header" }
const _hoisted_3 = { class: "drv-text-body-lg drv-text-weight-medium" }
const _hoisted_4 = { class: "row align-center" }
const _hoisted_5 = { class: "content-main" }

import { EEvents } from "~/types";
import { EMessagesKeys, IArticle } from "../types";
import ArticleContent from "./blocks/ArticleContent.vue";
import { ref, watch } from "vue";
import { api } from "../services";
import { injector } from "@/services";
import { EVENT_BUS_SERVICE_INJECTION_KEY } from "@/constants";
import { openURL } from "draivn-ui-kit";


export default /*@__PURE__*/_defineComponent({
  __name: 'SidebarComponent',
  props: {
    modelValue: { type: Boolean }
  },
  setup(__props: any) {

const eventBusService = injector.injectFromRoot(
  EVENT_BUS_SERVICE_INJECTION_KEY
);

const props = __props;

const loading = ref<boolean>(false);

const article = ref<IArticle | null>(null);
const articleLink = ref<string>("");
const articlePath = ref<string[]>(articleLink.value.split("/"));
const root = ref<string>(articlePath.value[0]);
const group = ref<string>(articlePath.value.slice(-2)[0]);
const articleId = ref<string>(articlePath.value.slice(-1)[0]);

const activeArticleLink = ref<string>(articlePath.value.join("/"));

watch(articleLink, async (link: string) => {
  if (link !== activeArticleLink.value && link) {
    const currentPath = link.split("/");
    articlePath.value = currentPath;
    root.value = currentPath[0];
    group.value = currentPath.slice(-2)[0];
    articleId.value = currentPath.slice(-1)[0];

    if (!props.modelValue) {
      eventBusService.emit(EEvents.ON_LEFT_SIDEBAR_TOOGLE, false);
      eventBusService.emit(EEvents.ON_RIGHT_SIDEBAR_TOOGLE, true);
    }

    await updateArticle();
  }
});

const updateArticle = async () => {
  loading.value = true;
  article.value = await api.getArticle(group.value, articleId.value);
  loading.value = false;
};

const open = (link: string) => {
  articleLink.value = link;
  eventBusService.emit(EEvents.ON_LEFT_SIDEBAR_TOOGLE, !link);
  eventBusService.emit(EEvents.ON_RIGHT_SIDEBAR_TOOGLE, !!link);
};

const openExternal = () => {
  const link = `${
    process.env.VUE_APP_BASE_URL || window.location.origin
  }/help/article/${group.value}/${articleId.value}`;
  openURL(link);
};

const close = () => {
  eventBusService.emit(EEvents.ON_ARTICLE_LINK_CHANGE, "");
};

eventBusService.on(EEvents.ON_ARTICLE_LINK_CHANGE, open);

return (_ctx: any,_cache: any) => {
  const _component_d_tooltip = _resolveComponent("d-tooltip")!
  const _component_d_btn = _resolveComponent("d-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t(_unref(EMessagesKeys).HELP_CENTER_SIDE_TITLE)), 1),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_d_btn, {
          onClick: openExternal,
          label: _ctx.$t(_unref(EMessagesKeys).HELP_CENTER_SIDE_OPEN_EXTERNAL),
          variant: "secondary",
          "icon-right": "arrow-up-right",
          size: "sm",
          "text-color": "n600"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_d_tooltip, {
              offset: [10, 10],
              text: _ctx.$t(_unref(EMessagesKeys).HELP_CENTER_SIDE_OPEN_EXTERNAL_TOOLTIP)
            }, null, 8, ["text"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_d_btn, {
          onClick: close,
          class: "drv-ml-2",
          variant: "secondary",
          icon: "cross",
          size: "sm",
          "text-color": "n600"
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      (article.value)
        ? (_openBlock(), _createBlock(ArticleContent, {
            key: 0,
            article: article.value
          }, null, 8, ["article"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})